import {usePlayerStore} from '@common/player/hooks/use-player-store';

function normalizeMediaIdentityPart(value: string | number | undefined): string {
  return value == null ? '' : `${value}`;
}

export function isMatchingMediaIdentity(
  currentMedia:
    | {
        id?: string | number;
        groupId?: string | number;
      }
    | undefined,
  mediaId: string | number,
  groupId?: string | number,
): boolean {
  if (!currentMedia) {
    return false;
  }

  if (
    normalizeMediaIdentityPart(currentMedia.id) !==
    normalizeMediaIdentityPart(mediaId)
  ) {
    return false;
  }

  if (groupId == null) {
    return true;
  }

  return (
    normalizeMediaIdentityPart(currentMedia.groupId) ===
    normalizeMediaIdentityPart(groupId)
  );
}

export function useIsMediaCued(
  mediaId: string | number,
  groupId?: string | number,
): boolean {
  return usePlayerStore(s => isMatchingMediaIdentity(s.cuedMedia, mediaId, groupId));
}
